import { buildSlice, CommonState } from '~libs/reduxUtils';

import { ClientWithBudget } from '~support-at-home/models';

import { getAll, typePrefix } from '~support-at-home/actions/clientsWithBudgets';

interface ClientsWithBudgetsState extends CommonState<ClientWithBudget> {
  params: { [key: string]: any };
  total: number;
}

const initialState: ClientsWithBudgetsState = {
  loading: 'idle',
  error: null,
  rows: [],
  params: { limit: 20 },
  total: 0,
};

const slice = buildSlice<ClientsWithBudgetsState, ClientWithBudget>(typePrefix, initialState, {
  extraReducers: (builder) => {
    builder.addCase(getAll.fulfilled, (state, action) => {
      const { data } = action.payload;
      const { rows, total } = data || { rows: [], total: 0 };
      state.rows = rows;
      state.total = total;
      state.loading = 'fulfilled';
    });
  },
});

export const { clear, updateParams } = slice.actions;
export default slice.reducer;
